/*
 * Asset-scoped document types (Models/Cmms/AssetDocumentType.cs).
 *
 * NOTE: this is NOT the same enum as `DocumentType` in cmmsWorkOrders/workOrderEnums.js,
 * which belongs to RelatedDocumentLink. The member names overlap but the numeric values
 * differ (Manual is 1 here, 4 there; Drawing 2 vs 3; Sop 4 vs 2), so importing the wrong
 * one is silently wrong rather than a build error. Asset documents always use this file.
 *
 * Labels live in cmmsMessages.js with the other enum label helpers, so they are
 * translated. Everything here is presentation that does not depend on locale.
 */
import { getAssetDocumentTypeLabel } from "./cmmsMessages";

export const AssetDocumentType = {
  Manual: 1,
  Drawing: 2,
  Certificate: 3,
  Sop: 4,
  Photo: 5,
  Other: 6,
};

export const assetDocumentTypeValues = [
  AssetDocumentType.Manual,
  AssetDocumentType.Drawing,
  AssetDocumentType.Certificate,
  AssetDocumentType.Sop,
  AssetDocumentType.Photo,
  AssetDocumentType.Other,
];

// Options for AxionSelect ({ id, title }), localized via intl.
export const getAssetDocumentTypeOptions = (intl) =>
  assetDocumentTypeValues.map((value) => ({ id: value, title: getAssetDocumentTypeLabel(value, intl) }));

const assetDocumentTypePalette = {
  [AssetDocumentType.Manual]: { bg: "#f57c00", text: "#fff" },
  [AssetDocumentType.Drawing]: { bg: "#7b1fa2", text: "#fff" },
  [AssetDocumentType.Certificate]: { bg: "#388e3c", text: "#fff" },
  [AssetDocumentType.Sop]: { bg: "#1976d2", text: "#fff" },
  [AssetDocumentType.Photo]: { bg: "#0097a7", text: "#fff" },
  [AssetDocumentType.Other]: { bg: "#9e9e9e", text: "#fff" },
};

export const getAssetDocumentTypeBadge = (type, intl) => ({
  label: getAssetDocumentTypeLabel(type, intl),
  ...(assetDocumentTypePalette[type] ?? { bg: "#9e9e9e", text: "#fff" }),
});

// The images a browser can show, and so the only ones the API takes as a node's overview
// image (AssetService.OverviewImageContentTypes). HEIC and TIFF upload fine as documents
// but would render as a broken image on the card.
export const OVERVIEW_IMAGE_CONTENT_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];

// The stored contentType is the header as it was uploaded, so it is compared the way the
// API compares it: without parameters and ignoring case.
export const isOverviewImageContentType = (contentType) =>
  OVERVIEW_IMAGE_CONTENT_TYPES.includes((contentType ?? "").split(";")[0].trim().toLowerCase());
